








































































import { Component, Vue, Prop } from 'vue-property-decorator'
import CreateRelation from '@/components/CreateRelation/index.vue'
import { UserStore, userInfoTypes } from '@/store/modules/User'

interface QUERY_INFO {
  startDate: string
  endDate: string
  startWeek: string
  endWeek: string
  roomNum: number
  adultNum: number
  childNum: number
}

@Component({
  name: 'ProductList',
  components: {
    CreateRelation
  }
})
export default class ProductList extends Vue {
  @Prop({
    type: Boolean,
    default: false
  })
  loading!: boolean

  /**
   * @param {Array} list 列表数据
   * @description: 数组类型数据
   */
  @Prop({
    type: Array,
    default: () => []
  })
  list!: Array<any>

  /**
   * @param {Array}  query参数
   * @description: 对象类型数据
   */
  @Prop({
    type: Object,
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    default: () => {}
  })
  queryInfo!: QUERY_INFO

  private readonly hotelStar = {
    1: '一',
    2: '二',
    3: '三',
    4: '四',
    5: '五'
  }

  private get userInfo (): userInfoTypes {
    return UserStore.userInfo
  }

  // 打开地图
  private clickMap = (item) => {
    let latitude = 0
    let longitude = 0
    if (item) {
      latitude = item.latitude || 0
      longitude = item.longitude || 0
    }
    if (latitude && longitude) {
      const url = `http://api.map.baidu.com/geocoder?location=${latitude},${longitude}&coord_type=bd09ll&output=html&src=zowoyoo`
      window.open(url, '_blank')
    }
  }

  // 跳转到酒店详情页面
  private goToDetail (item) {
    console.log(item, this.queryInfo)
    const { startDate, endDate, startWeek, endWeek, roomNum, adultNum, childNum } = this.queryInfo
    const queryParams = new URLSearchParams({
      hotelId: item.hotelId,
      startDate,
      endDate,
      startWeek,
      endWeek,
      roomNum: roomNum.toString(),
      adultNum: adultNum.toString(),
      childNum: childNum.toString()
    })
    const url = `${window.location.origin}/#/hotelDetail?${queryParams.toString()}`
    window.open(url)
  }

  mounted () {
    // console.log(this.queryInfo)
  }
}
